module.exports = __webpack_public_path__ + "static/media/Image_1.7fc88ab5.png";